module.exports = __webpack_public_path__ + "img/Frente-35-00 off.9661d1a4.png";